<div class="contractor-confirm-wrapper" [ngClass]="renderMode">
  <div class="confirm-box-title">
    {{ 'onboarding.submission.header' | translate }}
  </div>
  <div class="confirm-box-sub-title">
    {{ 'onboarding.submission.body' | translate }}
  </div>

  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="close-btns"
      data-test-id="btn-submit"
      (click)="onCloseClicked()"
    >
      Close
    </button>
  </div>
</div>
